import React, { ReactNode } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Account, AccountTypeEnum } from "@rentablo/api/apiv1";
import AccountPreviewIcon from "@components/Accounts/AccountPreviewCard/AccountPreviewIcon";

export const AccountRow = ({
  children,
  isLast,
}: {
  children: ReactNode;
  isLast?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      height={70}
      paddingRight={3}
      borderBottom={
        isLast ? "none" : `1px solid ${theme.palette.border.secondary}`
      }
    >
      {children}
    </Box>
  );
};

export const AccountInfo = ({
  account,
  isReference = false,
}: {
  account: Account;
  isReference?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Box display="flex" alignItems="center" gap={3} ml={3}>
      <AccountPreviewIcon
        isReference={isReference}
        iconUrl={account.iconUrl ?? ""}
        type={(account.type ?? "02_cash") as AccountTypeEnum}
        size={30}
        iconSize={20}
        bgColor={theme.palette.common.white}
      />
      <Box>
        <Typography variant="body2" fontWeight={600}>
          {account.name}
        </Typography>
        {account.bankName && (
          <Typography variant="body3" color="text.secondary">
            {account.bankName}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
